<template>
  <b-modal
    id="retrieve-configuration"
    title="Retrieve configuration"
    size="lg"
    centered
    ok-only
    @shown="onModalShown"
  >
    <div class="logged-in">
      <h3>Saved configurations</h3>
      <template v-if="!loggedUser">
        <div class="form-group">
          <label for="loginEmailInput">Your email</label>
          <input class="form-control" type="email" name="email" v-model="loginEmailInput" id="loginEmailInput">
        </div>
        <button class="btn btn-black-bg" @click="loadConfigurations">Load configurations</button>
      </template>
      <div class="user-configurations mt-3">
        <div v-if="loggedUserConfigurations.length == 0">
          <span class="general-content">
            Currently there are no saved configuration
          </span>
        </div>
        <table style="width: 100%" v-else>
          <thead>
            <tr>
              <th>#Code</th>
              <th>Bike</th>
              <th>Created at</th>
              <th v-if="loggedUser && loggedUser.email">Customer reference label</th>
              <th>Total price</th>
              <th class="d-none">Date sent</th>
              <th class="d-none" v-if="loggedUser && loggedUser.email" data-configurator-actions="1">Actions</th>
            </tr>
          </thead>
          <tr v-for="configuration in loggedUserConfigurations" v-bind:key="configuration.id"
            @click="$bvModal.hide('retrieve-configuration')">
            <td><a :href="'/configurator/?load=' + configuration.id">#{{ configuration.id }}</a></td>
            <td>
              <a :href="'/configurator/?load=' + configuration.id" v-if="getBikeById(configuration.bike_id) != null">{{
                getBikeById(configuration.bike_id).name
              }}</a>
            </td>
            <td>
              <a :href="'/configurator/?load=' + configuration.id">
                {{ formatDate(configuration.created_at) }}
              </a>
            </td>
            <td v-if="loggedUser && loggedUser.email">
              {{ configuration.customer_reference_label || '—' }}
            </td>
            <td>
              <a :href="'/configurator/?load=' + configuration.id">
                {{ formatPrice(configuration.price) }}
              </a>
            </td>
            <td class="d-none">
              {{ formatSentAt(configuration) }}
            </td>
            <td class="d-none" v-if="loggedUser && loggedUser.email" data-configurator-actions-cell="1" @click.stop>
              <button
                v-if="!configuration.is_confirmed"
                type="button"
                class="btn btn-sm btn-outline-danger"
                style="padding: 5px !important;min-height: auto;"
                @click="confirmDelete(configuration)"
              >
                Delete
              </button>
            </td>
          </tr>
        </table>
      </div>
    </div>

  </b-modal>
</template>

<script>
import axios from "axios"

export default {
  name: "configuration-modal",
  data() {
    return {

    }
  },
  created() {
    //this.loadConfigurations();
  },
  props: [
    "loggedUser",
    "loginEmailState",
    "loginEmail",
    "loginPasswordState",
    "loginPassword",
    "loggedUserConfigurations",
    "bikes"
  ],
  computed: {
    loginEmailInput: {
      get: function () {
        return this.loginEmail;
      },
      set: function (e) {
        this.$emit("set-login-email", e);
      },
    },
    loginPasswordInput: {
      get: function () {
        return this.loginPassword;
      },
      set: function (e) {
        this.$emit("set-login-password", e);
      },
    },
  },
  methods: {
    resolveLoadEmail: function () {
      if (this.loggedUser && this.loggedUser.email) {
        return this.loggedUser.email;
      }
      return this.loginEmail;
    },
    onModalShown: function () {
      if (this.loggedUser && this.loggedUser.email) {
        this.loadConfigurations();
      }
    },
    loadConfigurations: function () {
      var email = this.resolveLoadEmail();
      if (email == null || email === "") {
        this.$emit('set-error', 'Insert a valid email address');
        return [];
      }
      axios
        .get(
          "/api/mtm-configurator/configurations/load/" +
            encodeURIComponent(email)
        )
        .then((res) => {
          this.$emit('set-login-res', res.data);
        })
        .catch((error) => {
          if (error.response) {
            this.$emit(
              'set-error',
              'Cannot load configuration. Error: ' +
                (error.response.data && error.response.data.error
                  ? error.response.data.error
                  : error.response.status)
            );
          }
        });
    },
    getBikeById: function (id) {
      return this.bikes.filter((e) => {
        if (e.id == id) {
          return e;
        }
      })[0];
    },
    formatDate: function (datestr) {
      const date = new Date(datestr);

      // Ottiene i valori di giorno, mese, anno, ora e minuti dalla data
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      // Formatta la data e l'ora nel formato richiesto
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    },
    formatPrice: function (price) {
      const value = Number(price);
      if (Number.isNaN(value)) {
        return "—";
      }

      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "EUR",
        minimumFractionDigits: 0,
      }).format(value);
    },
    /**
     * Data/ora invio conferma (solo se il backend espone confirmed_at).
     */
    formatSentAt: function (configuration) {
      if (!configuration || !configuration.confirmed_at) {
        return '—';
      }
      return this.formatDate(configuration.confirmed_at);
    },
    confirmDelete: function (configuration) {
      if (
        !window.confirm(
          "Delete this configuration? This cannot be undone."
        )
      ) {
        return;
      }
      axios
        .delete(
          "/api/mtm-configurator/configuration/" + configuration.id
        )
        .then(() => {
          this.loadConfigurations();
        })
        .catch((error) => {
          var msg = "Could not delete configuration.";
          if (error.response && error.response.data) {
            if (error.response.data.message) {
              msg = error.response.data.message;
            } else if (typeof error.response.data === "string") {
              msg = error.response.data;
            }
          }
          this.$emit("set-error", msg);
        });
    },
  },
};
</script>
